import styled from '@emotion/styled';
import Logout from '@mui/icons-material/Logout';
import Settings from '@mui/icons-material/Settings';
import { Badge } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import LanguageSwitcher from 'components/LanguageSwitcher';
import { onMessageListener, requestPermission } from 'firebaseConf/firebaseConfig2';
import * as React from 'react';
import { useAuthUser, useSignOut } from 'react-auth-kit';
import Draggable from 'react-draggable'; // Importer Draggable
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';// Import useTranslation
import { MdNotifications, MdNotificationsActive } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

export default function AccountMenu() {
  const { t: tAccountMenu } = useTranslation('account_menu');
  const { t: tNotifications } = useTranslation('notifications');

  const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      backgroundColor: '#44b700',
      color: '#44b700',
      '&::after': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '120%',
        height: '120%',
        borderRadius: '50%',
        animation: 'ripple 1.2s infinite ease-in-out',
        border: '5px solid currentColor',
        content: '""',
      },
    },
    '@keyframes ripple': {
      '0%': {
        transform: 'scale(.8)',
        opacity: 1,
      },
      '100%': {
        transform: 'scale(3.4)',
        opacity: 0,
      },
    },
  }));

  const [anchorEl, setAnchorEl] = React.useState(null);
  const auth = useAuthUser();
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const signOut = useSignOut();

  const navigate = useNavigate();
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [newNotif, setNewNotif] = React.useState(false); // Renommé pour clarté

  React.useEffect(() => {
    requestPermission();

    onMessageListener()
      .then((payload) => {
        setNewNotif(true);
        console.log(tNotifications('received_foreground_message'), payload);// Traduit
        toast(
          (t) => (
            <span className="flex items-center min-w-[100px]">
              <span className="">
                <p className="font-bold">{payload?.notification?.title}</p>
                <p>{payload?.notification?.body}</p>
              </span>
              <span className="">
                <i className="bi bi-x-circle text-red-300" onClick={() => toast.dismiss(t.id)} />
              </span>
            </span>
          ),
          {
            duration: 100000,
            position: 'top-right',
          }
        );
      })
      .catch((err) => {
        console.log(tNotifications('failed_to_receive_message'), err);// Traduit
      });
  }, [tNotifications]);// Ajouter tNotifications aux dépendances

  return (
    <React.Fragment>
      <Draggable>
        <Box
          style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            zIndex: 1300,
            cursor: 'move',
          }}
        >
          <Tooltip title={tAccountMenu('account_settings_tooltip')}>
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ backgroundColor: 'orange' }}
              className="shadow-lg"
              aria-controls={open ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
            >
              <StyledBadge
                overlap="circular"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                variant={newNotif ? 'dot' : 'standard'}
              >
                <Avatar className="bg-green-200" sx={{ width: 42, height: 42 }}>
                  {auth()?.user?.firstName && auth()?.user?.lastName
                    ? auth()?.user?.firstName[0] + auth()?.user?.lastName[0]
                    : ''}
                </Avatar>
              </StyledBadge>
            </IconButton>
          </Tooltip>
        </Box>
      </Draggable>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem
          onClick={() => {
            setNewNotif(false);
            navigate('/admin/notifications');
          }}
        >
          <ListItemIcon>
            {newNotif ? <MdNotificationsActive size={25} color="red" /> : <MdNotifications />}
          </ListItemIcon>
          {tAccountMenu('notifications_menu_item')}
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          {tAccountMenu('settings_menu_item')}
        </MenuItem>
        <MenuItem onClick={signOut}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          {tAccountMenu('logout_menu_item')}
        </MenuItem>
        <MenuItem>
          <LanguageSwitcher />
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}